module.exports = __webpack_public_path__ + "static/media/ins19.6e66cd44.jpg";